module.exports = __webpack_public_path__ + "static/media/subscription.d3f8f3d6.svg";